import { LanguageProvider } from './i18n';
import Navbar from './components/Navbar';
import Hero from './sections/Hero';
import Servicios from './sections/Servicios';
import Proyectos from './sections/Proyectos';
import Colaboraciones from './sections/Colaboraciones';
import Footer from './sections/Footer';
import './App.scss';

const App = () => (
  <LanguageProvider>
    <div className="app">
      <a href="#main" className="skip-link">Saltar al contenido</a>
      <Navbar />
      <main id="main">
        <Hero />
        <Servicios />
        <Proyectos />
        <Colaboraciones />
        <Footer />
      </main>
    </div>
  </LanguageProvider>
);

export default App;
